// const __HIDE_WHY_SUBSCRIBE__ =
//   null;
// console.log("123123123123123")
// console.log(__HIDE_WHY_SUBSCRIBE__)
// const __WHY_SUBSCRIBE_HTML__ =
//   "";

import { LitElement, html, css } from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

const skioStyles = css`
  .skio-plan-picker {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 0;
    border: 0;
    margin-bottom: 25px;
  }
  .skio-onetime-second {
    order: 2;
  }

  .skio-group-container { display: none; }
  .skio-group-container--available {
    display: block;
    position: relative;
    box-shadow: 0 0 5px rgba(23, 24, 24, 0.05), 0 1px 2px rgba(0, 0, 0, 0.07);
    border-radius: 5px;
    border-width: 1px;
    border-color: transparent;
    border-style: solid;
    transition: border-color 0.2s ease;
  }
  .skio-group-container--selected { border-color: #000; }

  .skio-group-input {
    position: absolute;
    width: 0px;
    height: 0px;
    opacity: 0;
  }
  .skio-group-input:focus-visible ~ .skio-group-label {
    outline: 2px #ccc solid;
    outline-offset: 4px;
    border-radius: 5px;
  }

  .skio-group-label {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    padding: 10px;
    overflow: hidden;
  }

  .skio-group-topline {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    width: 100%;
    font-size: 16px;
  }

  .skio-radio__container { display: flex; margin-right: 10px; }

  .skio-radio {
    transition: transform 0.25s cubic-bezier(0.4,0,0.2,1), opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    transform-origin: center;
    transform: scale(0);
    opacity: 0;
  }
  .skio-group-label:hover .skio-radio { transform: scale(1); opacity: 0.75; }
  .skio-group-container--selected .skio-group-label .skio-radio { transform: scale(1); opacity: 1; }

  .skio-price { margin-left: auto; }

  .skio-group-content {
    width: auto;
    margin-left: 30px;
    transition: max-height 0.25s cubic-bezier(0.4,0,0.2,1),
                opacity 0.25s cubic-bezier(0.4,0,0.2,1);
    max-height: 38px;
    opacity: 1;
  }

  .skio-group-container:not(.skio-group-container--selected) .skio-group-content {
    max-height: 0;
    opacity: 0;
    pointer-events: none;
  }

  .skio-group-title { min-width: max-content; }

  .skio-save {
    background-color: #305456;
    color: white;
    padding: 0px 8px;
    border-radius: 20px;
  }

  .skio-frequency {
    display: flex;
    align-items: center;
    gap: 5px;
    padding: 8px 30px 8px 10px;
    margin-top: 5px;
    border-radius: 5px;
    background-color: #fff;
    width: 100%;
    border: 0;
    font-size: 14px;
    font-family: inherit;
    white-space: nowrap;
    cursor:pointer;
    text-overflow: ellipsis;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' class='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor' stroke-width='2'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' d='M19 9l-7 7-7-7' /%3E%3C/svg%3E");
    background-position: right 10px top 50%;
    background-size: 18px;
    background-repeat: no-repeat;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    padding-right: 25px;
    width: max-content;
    border: 1px solid rgba(2, 24, 50, .15);
    margin: 0px 0px 10px 0px;
    font-size: var(--typeBaseSize);
    height: 44px;
    border-radius: 4px;
    max-width: 210px;
    width: 100%;
  }
  .skio-frequency.skio-frequency--one { background-image: none; pointer-events: none; }
  .skio-frequency span { text-transform: lowercase; }
  .skio-price .crossed-price { display:none; }

  @media (max-width:767px) {
    .skio-price .crossed-price { display:block; position:relative; top:5px; }
    .skio-price { display: flex !important; flex-direction: column; }
    .skio-price .crossed-price::before {
      content: "";
      width: calc(6px + 100%);
      height: 1px;
      background: #000;
      position: absolute;
      top: 39%;
      left: -3px;
    }
    .skio-price .crossed-price::after {
      content: "";
      width: calc(6px + 100%);
      height: 1px;
      background: #000;
      position: absolute;
      top: 55%;
      left: -3px;
    }

    .skio-plan-picker{
      gap:0px !important;
      border: 1px solid #578B91 !important;
      border-radius: 4px !important;
      margin-left: 0px;
      margin-right: 0px;
    }
    .skio-group-label { padding: 10px 15px; }
    .skio-plan-picker [skio-group-container]:first-of-type {
      border-bottom: 1px solid #578B91 !important;
      border-bottom-left-radius: 0 !important;
      border-bottom-right-radius: 0 !important;
    }
    .skio-group-topline{
      color: #041C1B;
      font-family: Helvetica;
      font-weight: 700;
      font-size: 14px;
      line-height: 19.6px;
      letter-spacing: -0.14px;
      vertical-align: middle;
    }
    .skio-save {
      background: #FFC942 !important;
      font-size: 11.8px;
      font-weight: 400;
      padding: 4px 9.45px !important;
      border-radius: 2px !important;
      margin-left: 7.8px;
      color:black !important;
      text-transform: uppercase;
    }
    .skio-price{
      color: #041C1B;
      font-family: Helvetica;
      font-weight: 700;
      font-size: 14px;
      line-height: 19.6px;
      letter-spacing: -0.14px;
      vertical-align: middle;
    }
    .skio-group-container--selected{ border:none !important; box-shadow:none !important; background: #ECF1F5 !important; }
    .skio-group-container--available{ border: none !important; box-shadow: none !important; }
    ul > li{ list-style: none; }
  }

  .skio-plan-tabs {
    display: flex;
    gap: 0;
    // border: 1px solid rgba(2, 24, 50, .15);
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 20px;
    min-height:270px;
    position:relative;9
  }
  .skio-plan-tabs.no-save {
        min-height: 248px;
  }  

  .skio-subscribe-tab {
    flex: 1 1 0%;
    background: #e7f4f4;
    border: none;
    padding: 20px 18px 31px;
    transition: 0.2s;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0px;
  }

  .skio-onetime-tab {
    flex: 1;
    background: white;
    padding: 20px 18px 42.5px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .skio-tab-title {
    font-family: 'Roboto';
    letter-spacing: 0px;
    color: #000;
    font-size: 22px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    margin-bottom: 3px;
    font-style: normal;
  }

  .skio-tab-price {
    font-weight: 700;
    font-size: 14px;
    line-height: 19.6px;
    letter-spacing: -0.14px;
    color: #041C1B;
    font-family: var(--typeBasePrimary), var(--typeBaseFallback);
    position:relative;
  }

  .skio-tab-price--subscribe {
    color: #305456;
    font-size: 24px;
    font-weight: 700;
    line-height: normal;
    text-transform: uppercase;
    font-style: normal;
    font-family: var(--typeBasePrimary), var(--typeBaseFallback);
    margin-right: 4px;
    position:relative;
  }
  .skio-tab-price.crossed-price {
    color: #000;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    text-transform: uppercase;
    font-style: normal;
    font-family: var(--typeBasePrimary),var(--typeBaseFallback);
    position:relative;
  }
  .skio-save-badge {
    background: #FFC942;
    color: black !important;
    font-size: 11.8px;
    font-weight: 400;
    padding: 4px 9px;
    border-radius: 2px;
    text-transform: uppercase;
    margin-left: auto;
    display:none;
  }

  .skio-benefits {
    list-style: none;
    padding: 0;
    margin: 5px 0 0 0;
    font-size: 12px;
    color: #041C1B;
  }
  .skio-benefits li {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 8px;
    color: #000;
    font-size: calc(var(--typeBaseSize));
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    font-style: normal;
    letter-spacing: .24px;
  }
  .skio-benefits svg, .skio-benefits svg circle {
    flex-shrink: 0;
    margin-top: 2px;
    fill: color(srgb 0.0039 0.0922 0.1956);
  }
  .skio-benefits svg circle {
    fill:#305456;
  }
  .skio-toggle {
    margin-left: auto;
    flex: 0 0 auto;
    display: block;
    width: 70px;
    height: 33px;
    background: #fff;
    border-radius: 90px;
    position: relative;
    cursor: pointer;
    transition: background .3s ease;
    border: 1px solid #01142a;
    position: absolute;
    right: 18px;
    top: 20px;
    z-index: 9;
  }
  .skio-toggle input { opacity: 0; width: 0; height: 0; }
  .skio-toggle .track { position: absolute; inset: 0; border-radius: 999px; background: #fff; }
  .skio-toggle .thumb {
    left: 4px;
    background: #cbcbcb;
    content: "";
    position: absolute;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    top: 3px;
    transition: .3s ease;
  }
  .skio-toggle input:checked + .track { background: #305456; }
  .skio-toggle input:checked + .track .thumb { left: 40px; background: #fff; }

  .skio-subscribe-tab, .skio-onetime-tab { display: none !important; }
  .skio-subscribe-tab.skio-active, .skio-onetime-tab.skio-active { display: flex !important; }

  .wrap-subscription-dropdown-price {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-top: 13px;
  }
  .price-wrap-sub { 
  width: fit-content; 
  position: absolute;
    right: 22px;
    top: 30%;
    z-index: 9;
  }

  #getsunmed_pdp_susb_save_subs_info_content {
    color: #69989d;
    white-space: nowrap;
    font-size: calc(var(--typeBaseSize));
    font-weight: 400;
    line-height: normal;
    text-transform: capitalize;
    font-style: normal;
    letter-spacing: .24px;
    margin-right: 4px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    -webkit-text-decoration-skip: ink;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: auto;
    text-underline-offset: auto;
    text-underline-position: from-font;
    cursor: pointer;
  }
  .skio-onetime-tab > .skio-tab-price {
      margin-top: 26px;
      margin-bottom: 5px;
      color: #000;
      font-size: 24px;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      font-style: normal;
      margin-left: auto;
      opacity: 0;
      transform: translateX(15px);
      // animation: priceSlide 500ms cubic-bezier(0.4, 0, 1, 1) 0.2s both;
      position: relative;
  }
  .skio-tab-price {
      color: #305456;
      font-size: 24px;
      font-weight: 700;
      line-height: normal;
      text-transform: uppercase;
      font-style: normal;
      font-family: var(--typeBasePrimary), var(--typeBaseFallback);
      margin-right: 4px;
      position: relative;
      opacity: 0;
      transform: translateX(15px);
      // animation: priceSlide 800ms cubic-bezier(0.4, 0, 1, 1) 0.1s both;
  }
  .single-option-desc-wrap {
      margin-top: 15px;
  }
  .getsunmed_pdp_susb_save_subs_onetime_left_saving_copy {
      margin: 0px;
      margin-bottom: 3px;
      color: #000;
      font-size: 19px;
      font-weight: 400;
      line-height: normal;
      font-style: normal;
  }
  .getsunmed_pdp_susb_save_subs_onetime_left_lower_cta {
      margin: 0px;
      color: #578b91 !important;
      font-size: 19px;
      font-weight: 600;
      line-height: normal;
      text-decoration-line: underline;
      text-decoration-style: solid;
      -webkit-text-decoration-skip: ink;
      text-decoration-skip-ink: auto;
      text-decoration-thickness: auto;
      text-underline-offset: auto;
      text-underline-position: from-font;
      margin-bottom: 3px;
      margin-top: 37px;
      cursor: pointer;
      font-style: normal;
  }
  #getsunmed_pdp_susb_save_subs_info_content + span {
    color:#69989d;
  }

    .skio-active .skio-tab-price--subscribe {
  opacity: 0;
  transform: translateX(15px);
  // animation: priceSlide 800ms cubic-bezier(0.4, 0, 1, 1) 0.1s both;
}

.skio-active .skio-tab-price.crossed-price {
  opacity: 0;
  transform: translateX(15px);
  // animation: priceSlide 1100ms cubic-bezier(0.4, 0, 1, 1) 0.2s both;
  position: relative;
}

.skio-active .skio-tab-price.crossed-price::after {
    content: '';
    position: absolute;
    top: 47%;
    right: 0;
    width: 0;
    height: 1px;
    background: linear-gradient(90deg, #000000, #000, #000);
    transform-origin: right;
    // animation: strikeBounce 1300ms linear 0.4s both;
}

.skio-active .skio-tab-price.crossed-price.single-crossed::after {
  content: '';
  position: absolute;
  top: 47%;
  left: 0;              /* anchor to left */
  right: auto;
  width: 0;
  height: 1px;
  background: linear-gradient(90deg, #000000, #000, #000);
  transform-origin: left; /* grow from left edge */
  // animation: strikeBounceLtr 1300ms linear 0.4s both;
}
  .skio-tab-price.single::after {
    content: '';
    position: absolute;
    top: 47%;
    right: 0;
    width: 0;
    height: 1px;
    background: linear-gradient(90deg, #000000, #000, #000);
    transform-origin: right;
    // animation: strikeBounce 1300ms linear 0.4s reverse;
  }
/* Base: keep transitions smooth */
.price-wrap-sub .skio-tab-price--subscribe,
.price-wrap-sub .skio-tab-price.crossed-price {
  transition: opacity 1000ms ease, transform 1000ms ease, font-size 1000ms ease;
  will-change: opacity, transform, font-size;
}

/* ===== SUBSCRIPTION state ===== */
/* Show subscribe price */
.price-wrap-sub.is-subscription .skio-tab-price--subscribe {
  opacity: 1;
  transform: translateX(0);
}

/* Crossed-price smaller in subscription view (18px) */
.price-wrap-sub.is-subscription .skio-tab-price.crossed-price {
  font-size: 18px; /* you already use 18px for crossed-price default */ /* [file:1] */
}

/* Strike-through appears smoothly in subscription state */
.price-wrap-sub.is-subscription .skio-tab-price.crossed-price::after {
  content: "";
  position: absolute;
  top: 10px;           /* keep your existing positioning logic */
  right: 0;
  width: 0;
  height: 1px;
  background: linear-gradient(90deg, #000000, #000, #000);
  transform-origin: right;
  animation: strikeBounce 1000ms linear 80ms both;
}

/* ===== ONETIME state ===== */
/* Fade out subscribe price */
.price-wrap-sub.is-onetime .skio-tab-price--subscribe {
  opacity: 0;
  transform: translateX(10px);
  pointer-events: none;
}

/* Crossed-price grows to 24px smoothly */
.price-wrap-sub.is-onetime .skio-tab-price.crossed-price {
  font-size: 24px;
  opacity: 1;
}

/* Remove strike-through in onetime state (no animation line) */
.price-wrap-sub.is-onetime .skio-tab-price.crossed-price::after {
  content: "";
  width: 0;
  animation: none;
}
/* base transition so it fades smoothly */
.price-wrap-sub .skio-tab-price--subscribe{
  transition: opacity 1000ms ease, transform 1000ms ease;
  opacity: 1;
  transform: translateX(0);
}

/* ✅ when onetime: fade out subscribe price */
.price-wrap-sub.is-onetime .skio-tab-price--subscribe{
  opacity: 0;
  transform: translateX(10px);
  pointer-events: none;
}
.price-wrap-sub.is-subscription .crossed-price {
    opacity: 1;
}
    /* Ensure pseudo-element exists in both states so it can animate out */
.price-wrap-sub .skio-tab-price.crossed-price::after{
  content: "";
  position: absolute;
  top: 13.5px;
  right: 0;
  height: 1px;
  background: linear-gradient(90deg, #000000, #000, #000);
  transform-origin: right;
  width: 0; /* default */
}

/* SUBSCRIPTION: animate line IN */
.price-wrap-sub.is-subscription .skio-tab-price.crossed-price::after{
  animation: strikeBounce 1000ms linear 80ms both;
}

/* ONETIME: animate line OUT (reverse) */
.price-wrap-sub.is-onetime .skio-tab-price.crossed-price::after{
  animation: strikeBounceReverse 1000ms linear 80ms both;
}

@keyframes strikeBounceLtr {
  0%   { width: 0;   transform: scaleX(0); }
  50%  { width: 60%; transform: scaleX(1.1); }
  100% { width: 105%;transform: scaleX(1); }
}
@keyframes strikeBounceReverse {
  0%   { width: 105%; transform: scaleX(1); }
  50%  { width: 60%;  transform: scaleX(1.1); }
  100% { width: 0;    transform: scaleX(0); }
}


@keyframes priceSlide {
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes strikeBounce {
  0% { width: 0; transform: scaleX(0); }
  50% { width: 60%; transform: scaleX(1.1); }
  100% { width: 105%; transform: scaleX(1); }
}

 @media (max-width: 767px) {
    .skio-plan-tabs {min-height: 235px;}
    .skio-plan-tabs.no-save {min-height: 208px;}
    .skio-benefits li:last-of-type {
        margin-bottom: 0px;
    }
    .skio-plan-tabs { flex-direction: column;margin-bottom: 0px; }
    .skio-onetime-tab { border-left: none; }
    .skio-onetime-tab {
      padding: 16px 12px;
    }
    .skio-subscribe-tab {
      padding:16px 12px;
    }  
    .skio-tab-title {
      font-size:15px; 
    } 
    .skio-toggle {
      width: 37px;
      height: 18px;
      position: absolute;
      top: 16px;
      right: 20px;
      z-index: 9;
    }  
    .skio-toggle .thumb {
      width: 14px;
      height: 14px;
          top: 2px
    }
    .skio-toggle input:checked + .track .thumb {
    left: 20px;
    }
    .price-wrap-sub {
        width: fit-content;
        flex-direction: column;
        display: flex;
        top: 20%;
        align-items: center;
    }
    .price-wrap-sub.is-subscription .skio-tab-price.crossed-price {
      font-size: 10px;
    }
    .price-wrap-sub.is-subscription .skio-tab-price.crossed-price::after {
        top: 5px;
    }
    .skio-tab-price {
      transform: none;
      width: fit-content;
    }  
    .price-wrap-sub.is-onetime .skio-tab-price.crossed-price {
        font-size: 16px;
        opacity: 1;
    }
    .price-wrap-sub > span {
        margin: 0px !important;
    }   
    .price-wrap-sub.is-subscription .skio-tab-price.crossed-price  {
      top:0px;
      transition: top 300ms ease;
    }
    .price-wrap-sub.is-onetime .skio-tab-price.crossed-price {
          top: -14px;
          transition: top 300ms ease;
    }  
    .price-wrap-sub .skio-tab-price.crossed-price::after {
      top:10px;
    }          
    .price-wrap-sub.two {
        margin-top: 23px !important;
    }
    .skio-tab-price,
    .skio-tab-price--subscribe {
          font-size: 16px;
    }
    .skio-tab-price.crossed-price {
      font-size:10px;
    }
    .skio-benefits svg {
      height:12px;
      width:12px;
    } 
    .skio-benefits li {
      margin-bottom:11px;
    }  
    .skio-onetime-tab > .skio-tab-price {
      font-size:16px;
    }  
    .getsunmed_pdp_susb_save_subs_onetime_left_lower_cta, 
    .getsunmed_pdp_susb_save_subs_onetime_left_saving_copy {
      font-size: 15px;
    }
    .model-main-wrap {
      max-width: 100%;
      border-radius: 0px;
      padding: 0px;
    }
    button.model-close-btn::before {
        font-size: 16px;
        text-transform: uppercase;
        position: relative;
        top: 1px;
    }
    button.model-close-btn {
        position:relative;
        top:unset;
        left:unset;
        right:unset;
        height: 50px;
        box-shadow: 0px 3px 4px 0px rgba(0,0,0,.25);
        width: 100%;
        padding: 10px;
        margin-left: auto;
        display: block;
        color: #000000;
        font-size: 20px;
        border: none;
        background: none;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 10px;
        font-family: var(--typeBasePrimary),var(--typeBaseFallback);
        letter-spacing: var(--typeBaseSpacing);
        line-height: var(--typeBaseLineHeight);
        font-weight: bold;
    }  
    .model-wrap .model-main-wrap .content-wrap {
        padding: 40px 30px 30px;
    }  
    button.end-close-btn {
      font-size: 13px;
      width: 100%;
      padding: 13px 33px;
    } 
    .getsunmed_pdp_susb_save_subs_info_content .model-main-wrap .content-wrap p {
      font-size: 15px;
    }         
  }
   
`;

export class SkioPlanPickerComponent extends LitElement {
  static properties = {
    product: { type: Object },
    productHandle: { type: String },
    key: { type: String },

    formId: { type: String },
    needsFormId: { type: Boolean },

    subscriptionFirst: { type: Boolean },
    startSubscription: { type: Boolean },
    discountFormat: { type: String },

    currency: { type: String },
    language: { type: String },
    moneyFormatter: {},

    externalPriceSelector: { type: String },
    externalPriceSelectorWithCurrency: { type: String },
    externalSaveSelector: { type: String },

    selectedVariant: { type: Object },
    skioSellingPlanGroups: {},
    availableSellingPlanGroups: {},
    selectedSellingPlanGroup: {},
    selectedSellingPlan: {},

    defaultFrequency: {},

    useVariantInputClickEvents: { type: Boolean },
    variantInputSelector: {}
  };

  static styles = skioStyles;

  constructor() {
    super();
    this.product = null;
    this.selectedVariant = null;

    this.productHandle = null;

    this.purchaseOption = 'onetime';

    this.key = null;
    this.formId = null;
    this.needsFormId = false;

    this.skioSellingPlanGroups = [];
    this.availableSellingPlanGroups = [];

    this.selectedSellingPlanGroup = null;
    this.selectedSellingPlan = null;

    this.startSubscription = false;
    this.subscriptionFirst = false;

    this.skioMainProduct = true;

    this.discountFormat = 'percent';

    this.externalPriceSelector = '[skio-external-price]';
    this.externalPriceSelectorWithCurrency = '[skio-external-price-with-currency]';
    this.externalSaveSelector = '[skio-external-save]';

    this.currency = Shopify.currency.active;
    this.language = 'en-US';
    this.moneyFormatter = new Intl.NumberFormat(this.language, {
      style: 'currency',
      currency: this.currency,
    });

    this.defaultFrequency = null;

    this.useVariantInputClickEvents = null;
    this.variantInputSelector = null;

    // Default subscribe flag (already in your code)
    this._skioUiInitialized = false;

    // ✅ Modal system state (NEW)
    this._modalHandlersBound = false;
    this._modalStackCount = 0;
    this._BASE_Z_INDEX = 10000;
    this._Z_INCREMENT = 1001;

    this._onModalRootClick = null;
    this._onModalRootCloseClick = null;

    // Optional mapping (keep for future triggers)
    this._modalMap = {
      'full-spectram-two': 'what-CBD-is'
    };
  }

  connectedCallback() {
    super.connectedCallback();

    if (this.startSubscription == true) {
      this.purchaseOption = 'subscription';
    }

    if(!this.product && this.productHandle) {
      this.fetchProduct(this.productHandle);
    }

    if (this.needsFormId && this.formId == null) {
      let forms = document.querySelectorAll('form[action="/cart/add"]');
      if (forms.length > 0) {
        let form;
        forms.forEach((el) => {
          if (el.hasAttribute('skio-key')) {
            if (el.getAttribute('skio-key') == this.key) form = el;
          }
        });
        if (!form) form = forms[0];
        this.formId = form.id;
        this.requestUpdate();
      }
    }

    let skio = this;
    document.addEventListener("variantChanged", function(e) {
      let variantId = e.detail.variantId;
      let variant = skio.product.variants.find(x => x.id == variantId);
      if (variant) skio.selectedVariant = variant;
      else skio.log("Unable to find variant with id: ", variantId);
      skio.requestUpdate();
    });

    if (this.useVariantInputClickEvents) {
      document.addEventListener('load', skio.addVariantClickEventListeners)
    }
  }

  // ✅ NEW: bind modal handlers after the first render. [web:235]
  firstUpdated() {
    this._bindModalHandlers();
  }

  // ✅ NEW: cleanup
  disconnectedCallback() {
    super.disconnectedCallback();
    this._unbindModalHandlers();
  }

  render() {
    if (!this.product || !this.selectedVariant || this.skioSellingPlanGroups.length == 0) return;

    const hideWhySubscribe = __HIDE_WHY_SUBSCRIBE__;
    // console.log('hidehidehidehidehide')
    // console.log(hideWhySubscribe)
    const defaultWhySubscribeContent = html`
    <p>Meditation doesn't transform us in a day — it takes about 8 weeks of consistent practice before the real benefits appear.</p>
    <p>The same's true for <span class="getsunmed_pdp_susb_save_subs_highlight">${PRODUCT_TITLE}</span>: our bodies need time to respond.</p>
    <p>We've worked with thousands who take <span class="getsunmed_pdp_susb_save_subs_highlight">${PRODUCT_TITLE}</span>.</p>
    <p>Those who take it for a few months see better results (much better results) than those who try it for a few weeks.</p>
  `;

  const sourceEl = document.querySelector('#why-subscribe-html');
//   console.log("iiiiiiiii111111111111")
//   console.log(sourceEl)
  const whyHtml = sourceEl ? sourceEl.innerHTML.trim() : '';
//    console.log("jjjjjjjjjjj2222222222")
//   console.log(whyHtml)
    const lines = (window.__WHY_SUBSCRIBE_TEXT__ || '')
    .split('\n')
    .map(s => s.trim())
    .filter(Boolean);
    // console.log('aaaaaaaa3343434343')
    // console.log(lines)
  const whySubscribeContent = lines.length
    ? html`
        <div class="content-wrap">
          ${lines.map(t => html`<p>${t}</p>`)}
        </div>
      `
    : html`<div class="content-wrap">${defaultWhySubscribeContent}</div>`;


    // console.log('dedededededddededed')
    // console.log(whySubscribeContent)

    const subscriptionGroup = this.availableSellingPlanGroups?.[0] || null;
    const plans = subscriptionGroup?.selling_plans || [];
    const selectedPlan = subscriptionGroup?.selected_selling_plan || null;

    const isSubscription = !!this.selectedSellingPlanGroup;

    const onToggle = (e) => {
      e.stopPropagation();
      const checked = e.currentTarget.checked;
      if (!subscriptionGroup) return;
      this.selectSellingPlanGroup(checked ? subscriptionGroup : null);
    };

    const checkSvg = html`
      <svg width="17" height="18" viewBox="0 0 17 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="9.05" r="8.5" fill="#305456"></circle>
        <path d="M4.5 9.05L7 12.05L12.5 7.05" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </svg>
    `;

    return html`
      <fieldset class="skio-plan-picker" skio-plan-picker="${this.key}">
        <input
          ${this.formId !== null ? html`form="${this.formId}"` : ''}
          name="selling_plan"
          type="hidden"
          value="${this.selectedSellingPlan?.id || ''}"
        />
        <input
          ${this.formId !== null ? html`form="${this.formId}"` : ''}
          name="properties[Discount]"
          type="hidden"
          value="${this.selectedSellingPlan ? this.discount(this.selectedSellingPlan).percent : ''}"
        />

        <div class="skio-plan-tabs ${!hideWhySubscribe == false ? 'no-save' : ''}">

          <div class="price-wrap-sub ${isSubscription ? 'is-subscription' : 'is-onetime'}">
            <span class="skio-tab-price skio-tab-price--subscribe">
              ${this.price(selectedPlan)}
            </span>

            <span class="skio-tab-price crossed-price">
              ${this.moneyFormatter.format(this.selectedVariant.price / 100)}
            </span>
          </div>

         <label class="skio-toggle" @click=${(ev) => ev.stopPropagation()}>
                <input type="checkbox" .checked=${isSubscription} @change=${onToggle} />
                <span class="track"><span class="thumb"></span></span>
              </label>
          <div class="skio-subscribe-tab ${isSubscription ? 'skio-active' : ''}">
            <div style="display:flex; width:100%; align-items:center; gap:12px;">
              <div class="skio-tab-title">SUBSCRIBE & SAVE ${ this.discountFormat == 'percent' ? this.discount(selectedPlan).percent : this.discount(selectedPlan).amount }</div>

            </div>

            <div class="wrap-subscription-dropdown-price">
              <select
                class="skio-frequency"
                ?disabled=${plans.length <= 1}
                @change=${(e) => subscriptionGroup && this.selectSellingPlan(e.target, subscriptionGroup)}
              >
                ${plans.map((plan) => html`
                  <option value="${plan.id}" ?selected=${selectedPlan?.id === plan.id}>
                    Delivery ${plan.name.toLowerCase()}
                  </option>
                `)}
              </select>
            </div>

            <ul class="skio-benefits">
              <li>${checkSvg}Lock in your discount for life</li>
              ${!hideWhySubscribe ? html`
                <li>
                  ${checkSvg}
                  <span class="open-modal-btn" id="getsunmed_pdp_susb_save_subs_info_content" style="text-decoration:underline;">
                    Why Subscribe?
                  </span>
                  <span> ←</span> Click
                </li>
              ` : html``}
              <li>${checkSvg} <span>Delivery every 30 days.<span style="text-transform:lowercase;"> ⏸️ or 🛑 with one click at any time.</span></span></li>
              <li>${checkSvg}30-Day Money Back Guarantee</li>
            </ul>

            ${this.discount(selectedPlan).percent !== '0%'
              ? html`<span class="skio-save-badge">Save ${this.discount(selectedPlan).percent}</span>`
              : html``}
          </div>

          <div class="skio-onetime-tab ${!isSubscription ? 'skio-active' : ''}">
            <div style="display:flex; width:100%; align-items:center; gap:12px;">
              <div class="skio-tab-title">JUST THIS ONCE</div>

            </div>
            <div class="single-option-desc-wrap">
              <p class="getsunmed_pdp_susb_save_subs_onetime_left_saving_copy">Want to save ${ this.discountFormat == 'percent' ? this.discount(selectedPlan).percent : this.discount(selectedPlan).amount }?</p>
              <p class="getsunmed_pdp_susb_save_subs_onetime_left_lower_cta"  
              @click=${(ev) => {
                ev.preventDefault();
                ev.stopPropagation();
                if (!subscriptionGroup) return;
                this.selectSellingPlanGroup(subscriptionGroup);
              }}>Switch to Subscription!</p>
            </div>
          </div>
        </div>
      </fieldset>

      <!-- Modal -->
      <div class="model-wrap getsunmed_pdp_susb_save_subs_info_content">
        <div class="model-close-wrap " style="display: none;"></div>
        <div class="model-main-wrap">
          <button class="model-close-btn">✕</button>
          ${whySubscribeContent}
          <button class="end-close-btn">CONTINUE</button>
        </div>
      </div>

      <style>
        .model-wrap{position:fixed;inset:0;display:block;opacity:0;visibility:hidden;transition:opacity .4s ease-in, visibility .4s ease-in;z-index:999999999999}
        .model-wrap.is-open{opacity:1;visibility:visible}
        .model-close-wrap{position:absolute;inset:0;background:rgba(0, 0, 0, 0.5);opacity:0;transition:opacity .4s ease-in;display:none}
        .model-wrap.is-open .model-close-wrap{display:block !important;opacity:1}
        .model-main-wrap{position:absolute;left:50%;top:50%;transform:translate(-50%,-46%) scale(.98);background:#fff;height: fit-content; max-width: 440px;width:100%;border-radius:0px;opacity:0;transition:opacity .25s ease, transform .25s ease;height: 100%; overflow-y: auto;margin-top: 0px;-ms-scroll-chaining: none;overscroll-behavior: none;height: fit-content; padding: 40px 30px 30px; border-radius: 8px;}
        .model-wrap.is-open .model-main-wrap{opacity:1;transform:translate(-50%,-50%) scale(1)}
        .model-close-btn,.end-close-btn,.open-modal-btn{cursor:pointer}
        button.model-close-btn { position: absolute; right: 6px; top: 4px; box-shadow: none; color: transparent; width: 40px; height: 40px; padding: 10px; margin-left: auto; display: block;color: #000000;font-size: 20px;border:none;background: none; }
        button.end-close-btn { background-color: #305456; color: #fff; border: none; border-radius: 2px; padding: 10px 33px; font-size: 16px; font-weight: 500; text-transform: uppercase; cursor: pointer; display: block; margin-left: auto; margin-right: auto; margin-top: 30px; font-family: var(--typeBasePrimary),var(--typeBaseFallback); }
        .getsunmed_pdp_susb_save_subs_info_content .model-main-wrap .content-wrap p { color: rgb(0, 0, 0); font-size: 18px; line-height: 1.5; margin: 0px 0px 20px; text-align: left; }
      </style>
    `;
  }

  // ---------------------------
  // ✅ MODAL LOGIC (NEW)
  // ---------------------------
  _bindModalHandlers() {
    if (this._modalHandlersBound) return;
    this._modalHandlersBound = true;

    this._onModalRootClick = (e) => {
      const trigger = e.target?.closest?.('.open-modal-btn, .scrolling-text');
      if (!trigger) return;

      const triggerId = trigger.id;
      const targetClass = this._modalMap?.[triggerId] || triggerId;

      // Query inside component DOM (ShadowRoot)
      const modal = this.renderRoot.querySelector(`.model-wrap.${CSS.escape(targetClass)}`);
      if (!modal) return;

      e.preventDefault();
      this._openModal(modal);
    };

    this._onModalRootCloseClick = (e) => {
      const btn = e.target?.closest?.('.model-close-wrap, .model-close-btn, .end-close-btn');
      if (!btn) return;

      const modal = btn.closest('.model-wrap');
      if (!modal) return;

      e.preventDefault();
      this._closeModal(modal);
    };

    this.renderRoot.addEventListener('click', this._onModalRootClick);
    this.renderRoot.addEventListener('click', this._onModalRootCloseClick);
  }

  _unbindModalHandlers() {
    if (!this._modalHandlersBound) return;
    this._modalHandlersBound = false;

    if (this._onModalRootClick) this.renderRoot.removeEventListener('click', this._onModalRootClick);
    if (this._onModalRootCloseClick) this.renderRoot.removeEventListener('click', this._onModalRootCloseClick);

    this._onModalRootClick = null;
    this._onModalRootCloseClick = null;
  }

  _openModal(modal) {
    if (!modal) return;

    this._modalStackCount++;
    const currentZ = this._BASE_Z_INDEX + (this._modalStackCount * this._Z_INCREMENT);

    modal.classList.add('is-open');
    modal.style.zIndex = String(currentZ);

    document.documentElement.style.overflow = 'hidden';

    const mars = document.querySelector('#marsello-widget-root');
    if (mars) mars.style.setProperty('z-index', 999999999, 'important');

    const pc = document.querySelector('#PageContainer');
    if (pc) {
      pc.style.position = 'relative';
      pc.style.zIndex = String(999999999999999);
    }

    const atc = document.querySelector('.btn-add-to-card-wrap');
    if (atc) atc.style.setProperty('z-index', '10', 'important');
  }

  _closeModal(modal) {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.style.zIndex = '';

    if (this._modalStackCount > 0) this._modalStackCount--;

    const anyOpen = this.renderRoot.querySelector('.model-wrap.is-open');

    if (!anyOpen) {
      const mars = document.querySelector('#marsello-widget-root');
      if (mars) mars.removeAttribute('style');

      const pc = document.querySelector('#PageContainer');
      if (pc) pc.removeAttribute('style');
    }

    setTimeout(() => {
      const stillOpen = !!this.renderRoot.querySelector('.model-wrap.is-open');
      if (!stillOpen) {
        document.documentElement.style.overflow = '';
        this._modalStackCount = 0;
      }
    }, 260);

    const atc = document.querySelector('.btn-add-to-card-wrap');
    if (atc) atc.removeAttribute('style');
  }

  // ---------------------------
  // EXISTING UPDATED LOGIC
  // ---------------------------
  updated = (changed) => {
    if(changed.has('product') && this.product) {
      this.key = this.key ? this.key : this.product.id;

      this.skioSellingPlanGroups = this.product.selling_plan_groups.filter(
        selling_plan_group => selling_plan_group.app_id === 'SKIO'
      );

      this.skioSellingPlanGroups.forEach((group) => {
        group.selling_plans.sort(function(a,b){
          if (parseInt(a.name.replace(/\D/g, "")) < parseInt(b.name.replace(/\D/g, ""))) return -1;
          if (parseInt(a.name.replace(/\D/g, "")) > parseInt(b.name.replace(/\D/g, ""))) return 1;
          if (parseInt(a.name.replace(/\D/g, "")) == parseInt(b.name.replace(/\D/g, ""))) return 0;
        })
      });
    }

    if(changed.has('selectedVariant') && this.selectedVariant) {
      this.availableSellingPlanGroups = this.skioSellingPlanGroups.filter(selling_plan_group =>
        selling_plan_group.selling_plans.some(selling_plan =>
          this.selectedVariant.selling_plan_allocations.some(
            selling_plan_allocation => selling_plan_allocation.selling_plan_id === selling_plan.id
          )
        )
      );

      if (this.availableSellingPlanGroups?.length > 0) {
        this.availableSellingPlanGroups.forEach((group => {
          if (this.defaultFrequency) {
            let selling_plan = group.selling_plans.find(x => x.name.toLowerCase().includes(this.defaultFrequency.toLowerCase()));
            if (selling_plan) group.selected_selling_plan = selling_plan;
            else group.selected_selling_plan = group.selling_plans[0];
          } else {
            group.selected_selling_plan = group.selling_plans[0];
          }
        }));

        if (this.startSubscription == true || this.product.requires_selling_plan == true || this.purchaseOption == 'subscription') {
          if (this.selectedSellingPlan == null || this.selectedSellingPlan == undefined) {
            let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.options[0].name.includes(this.selectedVariant.id));
            this.selectSellingPlanGroup(sellingPlanGroup);
          }

          let sellingPlanName = this.selectedSellingPlan.name;

          let sellingPlanGroup = this.availableSellingPlanGroups.find(x => x.selling_plans.find(y => y.name == sellingPlanName));
          let sellingPlan = sellingPlanGroup.selling_plans.find(y => y.name == sellingPlanName);
          if (sellingPlanName == sellingPlan.name) {
            this.selectedSellingPlanGroup = sellingPlanGroup;
            this.selectedSellingPlan = sellingPlan;
          } else {
            this.selectedSellingPlanGroup = this.availableSellingPlanGroups[0];
            this.selectedSellingPlan = this.availableSellingPlanGroups[0].selling_plans[0];
          }
        } else {
          this.selectedSellingPlan, this.selectedSellingPlanGroup = null
        }
      }

      // ✅ ADDED: force default Subscribe once, after groups exist
      if (!this._skioUiInitialized && this.availableSellingPlanGroups?.length > 0) {
        this._skioUiInitialized = true;
        this.selectSellingPlanGroup(this.availableSellingPlanGroups[0]);
      }

      this.updateForm();
    }

    if(changed.has('selectedSellingPlan')) {
      document.querySelectorAll(`[skio-price][skio-key="${ this.key }"]`).forEach((el) => {
        el.innerHTML = this.price(this.selectedSellingPlan);
      });

      document.querySelectorAll(`[skio-onetime-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan !== null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      document.querySelectorAll(`[skio-subscription-content][skio-key="${ this.key }"]`).forEach((el) => {
        this.selectedSellingPlan == null ? el.style.display = "none" : el.style.removeProperty('display');
      });

      const event = new CustomEvent(`skio::update-selling-plan`, {
        bubbles: true,
        composed: true,
        detail: {
          sellingPlan: this.selectedSellingPlan,
          key: this.key
        }
      });

      this.dispatchEvent(event);

      this.updateForm();
      this.updateExternalPrice();

      let sellingPlanInput = document.querySelector('input[name="selling_plan"]')
      this.selectedSellingPlan != null ? sellingPlanInput.value = this.selectedSellingPlan.id : sellingPlanInput.value = ''
    }

    if(changed.has('formId')) {
      this.updateForm();
    }
  }

  log = (...args) => {
    args.unshift('%c[skio]', 'color: #8770f2;');
    console.log.apply(console, args);
  }

  error = (...args) =>  {
    args.unshift('%c [skio]', 'color: #ff0000');
    console.error.apply(console, args);
  }

  updateExternalPrice() {
    document.querySelectorAll(this.externalPriceSelector).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan);
    })
    document.querySelectorAll(this.externalPriceSelectorWithCurrency).forEach((el) => {
      el.innerHTML = this.price(this.selectedSellingPlan) + ' ' + this.currency;
    })
    document.querySelectorAll(this.externalSaveSelector).forEach((el) => {
      let saveAmount = 0;
      if (this.selectedVariant.compare_at_price > this.selectedVariant.price) {
        saveAmount = this.selectedVariant.compare_at_price - this.selectedVariant.price;
      }
      if (this.selectedSellingPlan) {
        const sellingPlanDiscountAmount = this.discount(this.selectedSellingPlan).amount;
        saveAmount = saveAmount + sellingPlanDiscountAmount;
      }
      if (saveAmount <= 0) return
      el.innerHTML = 'Save ' + this.money(saveAmount);
    })
  }

  selectSellingPlanGroup(group) {
    this.selectedSellingPlanGroup = group;
    this.selectedSellingPlan = group?.selected_selling_plan;
    if (group) this.purchaseOption = 'subscription'
    else this.purchaseOption = 'onetime'
    this.updateForm();
  }

  selectSellingPlan(element, group) {
    let selling_plan = group.selling_plans.find(x => x.id == element.value);
    if (selling_plan) {
      group.selected_selling_plan = selling_plan;
      this.selectedSellingPlanGroup = group;
      this.selectedSellingPlan = selling_plan;
    }
    else this.log("Error: couldn't find selling plan with id " + element.value + " for variant " + this.selectedVariant.id + " from product " + this.product.id + " : " + this.product.handle);
  }

  money(price) {
    return this.moneyFormatter.format(price / 100.0)
  }

  discount(selling_plan) {
    if (!selling_plan) return { percent: '0%', amount: 0 }

    const price_adjustment = selling_plan.price_adjustments[0]
    const discount = { percent: '0%', amount: 0 }
    const price = this.selectedVariant.price;

    switch (price_adjustment.value_type) {
      case 'percentage':
        discount.percent = `${price_adjustment.value}%`
        discount.amount = Math.round((price * price_adjustment.value) / 100.0)
        break
      case 'fixed_amount':
        discount.percent = `${Math.round(((price_adjustment.value * 1.0) / price) * 100.0)}%`
        discount.amount = price_adjustment.value
        break
      case 'price':
        discount.percent = `${Math.round((((price - price_adjustment.value) * 1.0) / price) * 100.0)}%`
        discount.amount = price - price_adjustment.value
        break
    }

    return discount
  }

  price(selling_plan, formatted = true) {
    return formatted
      ? this.money(this.selectedVariant.price - this.discount(selling_plan).amount)
      : this.selectedVariant.price - this.discount(selling_plan).amount
  }

  updateForm() {
    if (this.formId) {
      let form = document.querySelector(`#${this.formId}`);

      if (form) {
        let selling_plan_input = form.querySelector('[name="selling_plan"]');
        if (selling_plan_input) {
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          selling_plan_input = document.createElement('input');
          selling_plan_input.type = "hidden";
          selling_plan_input.name = "selling_plan";
          selling_plan_input.value = this.selectedSellingPlan?.id !== undefined ? this.selectedSellingPlan?.id : null;
          selling_plan_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(selling_plan_input);
        }

        let discount_input = form.querySelector('[name="properties[Discount]"]');
        if (discount_input) {
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
        } else {
          discount_input = document.createElement('input');
          discount_input.type = "hidden";
          discount_input.name = "properties[Discount]";
          discount_input.value = this.selectedSellingPlan?.id !== undefined ? this.discount(this.selectedSellingPlan).percent : null;
          discount_input.disabled = this.selectedSellingPlan?.id !== undefined ? false : true;
          form.append(discount_input);
        }
      } else {
        console.log(`Skio error: form ID is ${ this.formId }, but no form with that ID was found.`);
      }
    }
  }

  addVariantClickEventListeners() {
    let variantInputs = document.querySelectorAll(this.variantInputSelector)
    let skio = this
    for (let el of variantInputs) {
      el.addEventListener('click', function(e) {
        let variantTitle = e.currentTarget.value
        skio.selectedVariant = skio.product.variants.find(variant => variant.title == variantTitle)
      })
    }
  }

  fetchProduct = (handle) => {
    return fetch(`/products/${ handle }.js`)
      .then((response) => response.json())
      .then((product) => {
        this.product = product;
        this.selectedVariant = product.variants[0];
        return product;
      });
  }
}

if (!customElements.get('skio-plan-picker')) {
  customElements.define('skio-plan-picker', SkioPlanPickerComponent);
}
